import { Params, ParamMap } from '@angular/router';

export const FIELD_TEAM_KEY = 'team';

interface TeamListArg {
	teamId?: number;
}

interface FieldTeamListArg {
	fieldTeamId?: number;
}

export const toFieldTeamParams = (args: FieldTeamListArg): Params =>
	args.fieldTeamId
		? {
				[FIELD_TEAM_KEY]: args.fieldTeamId
					? args.fieldTeamId
					: undefined,
		  }
		: undefined;

export const toFieldTeamListArgs = (paramMap: ParamMap): FieldTeamListArg =>
	paramMap.has(FIELD_TEAM_KEY)
		? {
				fieldTeamId: +paramMap.get(FIELD_TEAM_KEY),
		  }
		: undefined;

export const toTeamParams = (args: TeamListArg): Params =>
	args.teamId
		? {
				[FIELD_TEAM_KEY]: args.teamId ? args.teamId : undefined,
		  }
		: undefined;

export const toTeamListArgs = (paramMap: ParamMap): TeamListArg =>
	paramMap.has(FIELD_TEAM_KEY)
		? {
				teamId: +paramMap.get(FIELD_TEAM_KEY),
		  }
		: undefined;
